//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from "react"

// === API ===
import {on, removeListener, sendMessage} from "api/prokey/prokey.websocket";

//#endregion

const ExpressionContext = createContext()

//-----------------------------------------------------------------
function ExpressionProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [ id_expr     , setIdExpr      ] = useState( 0  );
  const [ id_pred     , setIdPred      ] = useState( 0  );
  const [ expressions , setExpressions ] = useState( [] );
  const [ predicates  , setPredicates  ] = useState( [] );
  
  const [ fields      , setFields      ] = useState( [] );
  const [ records     , setRecords     ] = useState( [] );
  const [ tables      , setTables      ] = useState( [] );
  const [ documents   , setDocuments   ] = useState( [] );
  const [ table_columns, setTableColumns ] = useState( {} );

  const [ is_saved , setIsSaved ] = useState( true );

  //#endregion

  //#region [EFFECT]
  
  useEffect( () => {
    //-----------------------------------------------------------------    
    function listener(data) {
      //-----------------------------------------------------------------
      initPredicates( data.rule.rule.PREDICATE?.values || [] );
      initExpression( data.rule.rule.RULE     ?.values || [] );
    }
    //-----------------------------------------------------------------    
    function listener2(data) {
      //-----------------------------------------------------------------
      const temp = data.fields.map( x=> {return {label: x, value: x} });
      setFields( temp );
    }
    //-----------------------------------------------------------------    
    function listener4(data) {
      //-----------------------------------------------------------------
      const temp = data.tables.map( x=> {return {label: x, value: x} });
      setTables( temp );
    }
    //-----------------------------------------------------------------    
    function listener3(data) {
      //-----------------------------------------------------------------
      const temp = data.documents;
      setDocuments( temp );
    }
    //-----------------------------------------------------------------    
    function listener5(data) {
      //-----------------------------------------------------------------
      const temp = data.records.map( x=> {return {label: x, value: x} });
      setRecords( temp );
    }
    //-----------------------------------------------------------------    
    function listener6(data) {
      //-----------------------------------------------------------------
      const temp = { ...table_columns };
      temp[data.table] = data.columns.map( x => { return {label: x, value: x} } );
      setTableColumns( temp );
    }

    on( 'ANALYTICS_RULE' , listener  );
    on( 'FIELD-LIST'     , listener2 );
    on( 'DOCUMENT-LIST'  , listener3 );
    on( 'TABLE-LIST'     , listener4 );
    on( 'RECORD-LIST'    , listener5 );
    on( 'TABLE-COLUMNS'  , listener6 );
    
    const message  = JSON.stringify( { type: 'FIELD-LIST-REQUEST', data: { } } );
    sendMessage( message );
    
    const message4 = JSON.stringify( { type: 'TABLE-LIST-REQUEST', data: { } } );
    sendMessage( message4 );
    
    const message2 = JSON.stringify( { type: 'DOCUMENT-LIST-REQUEST', data: { } } );
    sendMessage( message2 );
    
    const message5 = JSON.stringify( { type: 'RECORD-LIST-REQUEST', data: { } } );
    sendMessage( message5 );

    return () => {
      removeListener( 'ANALYTICS_RULE' , listener  );
      removeListener( 'FIELD-LIST'     , listener2 );
      removeListener( 'TABLE-LIST'     , listener4 );
      removeListener( 'DOCUMENT-LIST'  , listener3 );
      removeListener( 'RECORD-LIST'    , listener5 );
    };
  }, [] ); // empty dependency = called only once at startup

  useEffect(() => {
    const listener = (event) => {
      if( is_saved ) return;
      event.preventDefault();
      event.returnValue = 'test';
    }

    window.addEventListener('beforeunload', listener );

    return () => {
      window.removeEventListener('beforeunload', listener );
    };
  }, [is_saved]);

  //#endregion

  //#region [MODIFY] === EXPRESSION

  //-----------------------------------------------------------------
  function initExpression( values ) {
    //-----------------------------------------------------------------
    let count = id_expr;
    const array = values.map( data => { return { id: count++, data }; });
    setExpressions( array );

    setIdExpr( count+1 );
  }

  //-----------------------------------------------------------------
  function createExpression( data = {} ) {
    //-----------------------------------------------------------------
    const new_exp = { id: id_expr, data };
    setExpressions( [
      ...expressions,
      new_exp,
    ])

    setIdExpr( id_expr + 1 );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function updateExpression( id, data ) {
    //-----------------------------------------------------------------
    const temp = expressions.map( exp => {
      const is_exp = exp.id === id;
      if( is_exp ) {
        const new_data = { ...exp.data, ...data };
        const new_exp = { id: exp.id, data: new_data };
        return new_exp;
      }

      return exp;
    } );
    
    setExpressions( temp );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function removeExpression( id ) {
    //-----------------------------------------------------------------
    const temp = expressions.filter( exp => exp.id !== id );
    setExpressions( temp );
    setIsSaved( false );
  }

  //#endregion

  //#region [MODIFY] === PREDICATES

  //-----------------------------------------------------------------
  function initPredicates( values ) {
    //-----------------------------------------------------------------
    let count = id_pred;
    const array = values.map( data => { return { id: count++, data }; });
    setPredicates( array );

    setIdPred( count+1 );
  }

  //-----------------------------------------------------------------
  function createPredicate( data = {} ) {
    //-----------------------------------------------------------------
    const new_exp = { id: id_pred, data };
    
    setPredicates( [
      ...predicates,
      new_exp,
    ])

    setIdPred( id_pred + 1 );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function updatePredicate( id, data ) {
    //-----------------------------------------------------------------
    const temp = predicates.map( pred => {
      const is_exp = pred.id === id;
      if( is_exp ) {
        const new_data = { ...pred.data, ...data };
        const new_exp = { id: pred.id, data: new_data };
        return new_exp;
      }

      return pred;
    } );
    
    setPredicates( temp );
    setIsSaved( false );
  }

  //-----------------------------------------------------------------
  function removePredicate( id ) {
    //-----------------------------------------------------------------
    const temp = predicates.filter( exp => exp.id !== id );
    setPredicates( temp );
    setIsSaved( false );
  }

  //#endregion

  //-----------------------------------------------------------------
  function save( ) {
    //-----------------------------------------------------------------
    setIsSaved( true );
  }

  const values = { 
    expressions , setExpressions ,
    predicates  , setPredicates  ,
    removeExpression, createExpression, updateExpression,
    removePredicate , createPredicate , updatePredicate ,
    fields, documents, tables, records, table_columns,
    save, is_saved,
  };

  return (
    <ExpressionContext.Provider value={ values }>
      {children}
    </ExpressionContext.Provider>
  );
};

export { ExpressionContext, ExpressionProvider };